//Copyright Open Trade Technology Ltd. 2023. All rights reserved.

//  emit WithdrawRequested(owner, assets, shares);
import * as yup from 'yup'
import { InferType } from 'yup'
import { RoleEnum, yupEthAddr } from './Enums'
import { EthAddr, StringTypeEnum, toFieldMetaData } from './SchemaTypes'

export const OPEN_TRADE_UUID = '12345678-1234-4234-a234-123456789012'
export const ALL_UUID = '11111111-2222-4333-a444-555555555555'

export enum CompanyProfileStatusEnum {
  VERIFIED = 'VERIFIED',
  SIGNED_BY_LENDER = 'SIGNED_BY_LENDER',
  UNSIGNED = 'UNSIGNED',
}

export const CompanyProfileCTOSchema = yup.object({
  uuid: yup
    .string()
    .uuid()
    .required()
    .label('Event Id')
    .meta(toFieldMetaData({ propName: 'uuid' })),
  roleEnum: yup
    .mixed<RoleEnum>()
    .oneOf(Object.values(RoleEnum))
    .optional()
    .label('sourceObjectType')
    .meta(toFieldMetaData({ propName: 'roleEnum', choices: Object.keys(RoleEnum) })),
  companyName: yup
    .string()
    .required()
    .label('Company Name')
    .meta(toFieldMetaData({ propName: 'companyName' })),

  wallets: yup
    .array()
    .of(yupEthAddr.label('wallet').meta(toFieldMetaData({ propName: 'wallet', stringType: StringTypeEnum.ETH_ADDR })))
    .required()
    .label('Wallets')
    .meta(toFieldMetaData({ propName: 'wallets' })),

  emails: yup
    .array()
    .of(
      yup
        .string()
        .email()
        .required()
        .label('Email')
        .meta(toFieldMetaData({ propName: 'email' }))
    )
    .required()
    .label('Wallets')
    .meta(toFieldMetaData({ propName: 'emails' })),

  status: yup
    .mixed<CompanyProfileStatusEnum>()
    .oneOf(Object.values(CompanyProfileStatusEnum))
    .optional()
    .label('status')
    .meta(toFieldMetaData({ propName: 'status', choices: Object.keys(CompanyProfileStatusEnum) })),

  instructions: yup
    .string()
    .optional()
    .label('Instructions')
    .meta(toFieldMetaData({ propName: 'instructions' })),
})

export interface CompanyProfileCTO extends InferType<typeof CompanyProfileCTOSchema> {
  uuid: string
  wallets: EthAddr[]
  emails: string[]
  companyName: string
  instructions?: string
  status?: CompanyProfileStatusEnum
}
